import { gql } from '@apollo/client/core'

export const QUESTIONNAIRE_FIELDS = gql`
  fragment QuestionnaireFields on Questionnaire {
    id
    name
    description
    formTemplate
    formData
    parentableType
    parentableId
    answered
  }
`

export const FETCH_QUESTIONNAIRE_QUERY = gql`
  query FetchQuestionnaire($id: ID!) {
    questionnaire(id: $id) {
      ...QuestionnaireFields
    }
  }
  ${QUESTIONNAIRE_FIELDS}
`

export const FETCH_QUESTIONNAIRES_QUERY = gql`
  query FetchQuestionnaires($parentableId: ID!, $parentableType: String!) {
    questionnaires(parentableId: $parentableId, parentableType: $parentableType) {
      ...QuestionnaireFields
    }
  }
  ${QUESTIONNAIRE_FIELDS}
`

export const UPDATE_QUESTIONNAIRE_FORM_DATA = gql`
  mutation SubmitQuestionnaire($input: SubmitInput!) {
    submitQuestionnaire(input: $input) {
      questionnaire {
        ...QuestionnaireFields
      }
      errors {
        message
      }
    }
  }
  ${QUESTIONNAIRE_FIELDS}
`
